<script lang="ts" setup>
import { useLessonRoomStore } from '../../model/store'
import { useTracksLiveKit } from '../../model/tracks-live-kit.hook'
import { useLessonRoomAnalytics } from '../../model/lesson-room/lesson-room-analytics.hook'
import LessonRoomControlButton from '../lesson-room/LessonRoomControlButton.vue'

defineOptions({
  name: 'LiveKitButtonCamera',
})

const lessonRoomStore = useLessonRoomStore()
const { trackClickCam } = useLessonRoomAnalytics()

const {
  isCameraEnabled,
  toggleCamera,
} = useTracksLiveKit()

const handleClick = (): void => {
  trackClickCam()

  if (lessonRoomStore.isDeniedCam) {
    lessonRoomStore.setPermissionsBlocked(true)
    return
  }

  void toggleCamera()
}
</script>

<template>
  <LessonRoomControlButton
    :icon="isCameraEnabled ? { name: 'video' } : { name: 'video-slash' }"
    label="Camera"
    :enabled="isCameraEnabled"
    :danger="!isCameraEnabled"
    :alert="lessonRoomStore.isDeniedCam"
    @click="handleClick"
  />
</template>
